/* eslint-disable @typescript-eslint/no-redeclare */
export type FileUploadType =
  (typeof FileUploadType)[keyof typeof FileUploadType];
export const FileUploadType = {
  BRANDING_LOGO: 'BRANDING_LOGO',
  TEMPLATE_IMAGE: 'TEMPLATE_IMAGE',
} as const;
